import React from 'react';
import { Layout, Modal } from 'antd';
import { AppHeader, AppSider } from './components';

/**
 * 기본 레이아웃
 *   - Layout.Content를 각 페이지에 넣을 경우 컴포넌트 재활용성이 떨어지기 때문에 레이아웃에 넣음
 * @returns ReactNode
 */
export default function Basic(props) {
  const { children, menuId, currentPage } = props;

  function unauthorized() {
    Modal.warning({
      title: '인증 실패',
      content: '로그인 세션이 만료되었습니다.',
      okText: '로그인',
      onOk: () => Modal.destroyAll(),
      afterClose: () => children.props.history.push('/auth/login'),
    });
  }

  const useId = localStorage.getItem('userId');

  return (
    <>
      {!useId ? (
        unauthorized()
      ) : (
        <Layout style={{ height: '100vh' }}>
          <AppSider menuId={menuId} />
          <Layout>
            <AppHeader user={useId} history={children.props.history} currentPage={currentPage} />
            <Layout.Content style={{ overflow: 'auto' }}>{children}</Layout.Content>
          </Layout>
        </Layout>
      )}
    </>
  );
}
